<div class="filter-wrapper">
    <div class="filters-dropdown">
        <div class="filters">

            <div class="filter-group" *ngIf="tipoFiltro === 'documento'">
                <div class="filter-title">{{labelTipoDocumento}}</div>
                <nb-select [(selected)]="tipoDocumento" (selectedChange)="onTipoDocumentoChange($event)">
                    <nb-option value="all">Todos</nb-option>
                    <nb-option value="enviados">Enviados</nb-option>
                    <nb-option value="recibidos">Recibidos</nb-option>
                </nb-select>
            </div>

            <div class="filter-group" *ngIf="tipoFiltro === 'consulta'">
                <div class="filter-title">{{labelEstado}}</div>
                <nb-select [(selected)]="tipoEstado" (selectedChange)="onTipoEstadoChange($event)">
                    <nb-option value="all">Todas</nb-option>
                    <nb-option value="open">Abiertas</nb-option>
                    <nb-option value="closed">Cerradas</nb-option>
                </nb-select>
            </div>

            <div class="filter-group">
                <div class="filter-title">{{labelFechas}}</div>
                <button class="calendar-button" (click)="toggleCalendar()">
                    {{isCalendarVisible ? 'Ocultar calendario' : 'Seleccionar fechas'}}
                </button>
                <div *ngIf="isCalendarVisible" class="calendar-backdrop" (click)="toggleCalendar()"></div>
                <div *ngIf="isCalendarVisible" class="calendar-overlay">
                    <nb-calendar-range [(range)]="selectedDateRange" (rangeChange)="onDateRangeChange($event)"></nb-calendar-range>
                </div>
            </div>

            <!--<div class="filter-group" *ngIf="isMapfre">
                <div class="filter-title">{{labelProyectos}}</div>
                <nb-select [(selected)]="selectedProyecto" (selectedChange)="onProyectoChange($event)">
                    <nb-option value="all">Todos</nb-option>
                    <nb-option *ngFor="let proyecto of proyectos" [value]="proyecto.id">
                        {{proyecto.nombre}}
                    </nb-option>
                </nb-select>
            </div>-->

            <div class="filter-group">
                <div class="filter-title">{{labelBuscar}}</div>
                <app-input-search class="search-input" (onInputChange)="onSearch($event)"></app-input-search>
            </div>

            <div class="filter-actions">
                <button class="btn-clear-filters" (click)="clearFilters()">{{labelLimpiar}}</button>
            </div>
        </div>
    </div>
</div>

